/*
 * @Author: 40463 jia.rong.li@hand-china.com
 * @Date: 2024-12-12 08:52:39
 * @LastEditors: 40463 jia.rong.li@hand-china.com
 * @LastEditTime: 2024-12-24 15:02:12
 * @FilePath: \studyvux\src\utils\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';

// 创建 axios 实例
const instance = axios.create({
  baseURL: 'https://sh.nmdaqo.com:5020',  // 设置 API 的基础 URL
});

// 用于存储 token 的变量
let token = null;

// 获取 token 的方法，尝试从 localStorage 获取，若没有则请求接口获取
const getToken = async () => {
  
  // 尝试从 localStorage 获取 token（可根据需要使用 sessionStorage 或内存）
  const cachedToken = localStorage.getItem('access_token');
  if (cachedToken) {
    token = cachedToken;
    return token;
  }
  
  // 如果没有缓存的 token，发起请求获取 token
  try {
    const response = await axios.post('https://sh.nmdaqo.com:5020/oauth/oauth/token', null, {
      params: {
        grant_type: 'client_credentials',
        client_id: 'mateinout',
        client_secret: 'Init1234',
      },
    });
    if (response.data && response.data.access_token) {
      // 获取到 token，缓存到 localStorage 并返回
      token = response.data.access_token;
      console.log(response);
      
      localStorage.setItem('access_token', token);  // 缓存 token
      return token;
    } else {
      throw new Error('Failed to retrieve token');
    }
  } catch (error) {
    console.error('Error getting token:', error);
    throw error;
  }
};

// 设置 token（如果需要手动设置 token）
export const setToken = (newToken) => {
  token = newToken;
  localStorage.setItem('access_token', newToken);  // 可选，将 token 保存到 localStorage
};

// 封装的请求方法
export const request = async (method, url, data = null) => {
  try {
    localStorage.removeItem('access_token');
    const token = await getToken();  // 获取 token
    // alert('request中的请求地址:' + url)
    // alert('request中的请求方法:' + method)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    // 发起请求
    const response = await instance({
      method,
      url,
      data,
      headers,
    });
    if (response.status === 401) {
      // 如果 status 为 401, 清除本地存储并重新尝试请求
      localStorage.removeItem('access_token');
      const newToken = await getToken();  // 获取新的 token

      // 重新请求带上新的 token
      const newHeaders = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${newToken}`,
      };

      // 递归调用原请求函数，带上原始参数
      return instance({
        method,
        url,
        data,
        headers: newHeaders,
      });
    }

    return response;  // 返回请求结果
  } catch (error) {
    alert('请求出错', error);
    throw error;
  }
};




// WEBPACK FOOTER //
// ./src/utils/axios.js